import TitleHeader from "@/components/TitleHeader";
import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  Text,
  Image,
  Input,
} from "@chakra-ui/react";
import { Country } from "country-state-city";
import { useUserInfo } from "@/context/UserInfo";
import { useState } from "react";
const allCountry = Country.getAllCountries();
const CountryModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { countryInfo, handleSetCountryInfo } = useUserInfo();
  const [searchValue, setSearchValue] = useState("");

  const filteredCountry = allCountry.filter((item) => {
    const searchTerms = searchValue.toLowerCase().split(" ");
    const countryName = item.name.toLowerCase();

    return searchTerms.every((term) => {
      let lastIndex = -1;
      return term.split("").every((char) => {
        lastIndex = countryName.indexOf(char, lastIndex + 1);
        return lastIndex !== -1;
      });
    });
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"full"}>
      <ModalContent>
        <ModalBody
          sx={{
            height: "100%",
            padding: "0",
            width: "100%",
          }}
        >
          <Box sx={{ padding: "20px" }}>
            <TitleHeader
              title="Country / State"
              color="#D8762B"
              onBack={onClose}
            />
          </Box>
          <Box sx={{ padding: "0 30px" }}>
            <Text>Search country</Text>
            <Input
              variant="unstyled"
              placeholder="input to search"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              sx={{
                margin: "6px 0",
                fontSize: "14px",
                height: "20px",
              }}
            />
          </Box>
          <Flex
            sx={{
              height: "calc(100vh - 112px)",
              width: "100%",
            }}
          >
            <Flex
              sx={{
                width: "100%",
                height: "100%",
                overflowY: "auto",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                }}
              >
                {filteredCountry.map((item, index) => {
                  return (
                    <Flex
                      key={item.isoCode}
                      onClick={() => {
                        handleSetCountryInfo(item.isoCode, true);
                        onClose();
                      }}
                      sx={{
                        minHeight: "48px",
                        padding: "9px 0 9px 30px ",
                        alignItems: "center",
                        backgroundColor:
                          item.isoCode === countryInfo.countryIsoCode
                            ? "#FFD7AC"
                            : "#fff",
                        width: "100%",
                      }}
                    >
                      <Image
                        src={`https://images-country.meld.io/${item.isoCode}/flag.svg`}
                        sx={{
                          width: "30px",
                          height: "30px",
                          marginRight: "12px",
                          borderRadius: "50%",
                        }}
                      ></Image>
                      <Text
                        sx={{
                          color: "#333",
                          fontSize: "16px",
                          fontWeight: 500,
                        }}
                      >
                        {item.name}
                      </Text>
                    </Flex>
                  );
                })}
              </Box>
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CountryModal;
